var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"modal",attrs:{"title":"Session Expired","ok-only":""},on:{"close":_vm.modalClosed,"ok":_vm.modalClosed}},[_c('b-row',[_c('b-col',[_vm._v(" Your session has expired. You will now be redirected to log in. ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }